import { render, staticRenderFns } from "./NpcCard.vue?vue&type=template&id=37213c09&scoped=true"
import script from "./NpcCard.vue?vue&type=script&lang=js"
export * from "./NpcCard.vue?vue&type=script&lang=js"
import style0 from "./NpcCard.vue?vue&type=style&index=0&id=37213c09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37213c09",
  null
  
)

export default component.exports